import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
  html: true,
  breaks: false,
});

export default md;
